import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useFunnelStore } from "@/store";
import { useStepperStore } from "@/store/stepper";

const str = (v: unknown) => (typeof v === "string" ? v : undefined);

export const Route = createFileRoute("/start")({
  // QR-scan landing: `?ref=<code>` identifies the referrer whose KEY was scanned.
  validateSearch: (search: Record<string, unknown>) => ({
    ref: str(search.ref),
  }),
  component: StartRoute,
});

/**
 * QR-scan landing. Scanning a KEY QR sends the visitor here (not straight to
 * `/`, which resumes wherever they left off). We remember the referrer code,
 * clear any prior run, reset the stepper to its first step, then drop them into
 * the funnel at the very top — so every scan starts the flow fresh from step one.
 */
function StartRoute() {
  const navigate = useNavigate();
  const { ref } = Route.useSearch();
  const resetFunnel = useFunnelStore((s) => s.resetFunnel);

  useEffect(() => {
    if (ref) localStorage.setItem("secret-missions-ref", ref);
    resetFunnel();
    void (async () => {
      const store = useStepperStore.getState();
      if (store.status === "idle" || store.status === "error")
        await store.load();
      // Force back to the first step even for a returning visitor whose
      // persisted pointer would otherwise resume mid-run.
      useStepperStore.getState().reset();
      navigate({ to: "/", replace: true });
    })();
    // Mount-only: a scan always restarts the run.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <p className="text-center font-mono text-[11px] tracking-[0.22em] text-muted-foreground uppercase">
      Decrypting your orders…
    </p>
  );
}
